import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ dataComponents: { savedViews } }: ComposedTheme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  rootBorder: {
    height: 22,
    paddingLeft: 10,
    marginLeft: 8,
    borderLeft: `${savedViews.changed.borderColor} 1px solid`,
  },
  changed: {
    fontFamily: savedViews.changed.text.font.fontFamily,
    fontSize: savedViews.changed.text.font.fontSize,
    fontWeight: savedViews.changed.text.font.fontWeight,
    fontStyle: savedViews.changed.text.font.fontStyle,
    color: savedViews.changed.text.color,
    marginRight: 16,
  },
  secondButton: {
    marginLeft: 8,
    paddingLeft: 8,
    borderLeft: `${savedViews.changed.borderColor} 1px solid`,
    '&:nth-child(2)': {
      borderLeft: 0,
      paddingLeft: 0,
    },
  },
  input: {
    margin: [0, 16],
  },
  check: {
    '& svg': {
      fill: savedViews.saved.checkIconColor,
    },
  },
  saveSuccess: {
    fontFamily: savedViews.saved.text.font.fontFamily,
    fontSize: savedViews.saved.text.font.fontSize,
    fontStyle: savedViews.saved.text.font.fontStyle,
    fontWeight: savedViews.saved.text.font.fontWeight,
    color: savedViews.saved.text.color,
    marginLeft: 8,
  },
});

export default createUseStyles(styles);
